import AsciiMark from './AsciiMark';
import PartnersMarquee from './PartnersMarquee';
import '../styles/Hero.css';
import { useWalletModal } from './WalletModalContext';

/**
 * First full-viewport section. This is meant to sit as the first child
 * inside the sticky-stacking <main className="scroll-sections"> wrapper
 * (see styles/ScrollSections.css) — give it style={{ zIndex: 1 }} and
 * every section after it an increasing zIndex, so each new section
 * slides up and covers the one before it without the earlier section
 * moving at all.
 */
export default function Hero({ zIndex = 1 }) {
  const { open } = useWalletModal();

  return (
    <section id="home" className="hero section-panel" style={{ zIndex }}>
      <div className="hero__inner">
        <div className="hero__copy">
          <p className="hero__eyebrow">
            <span className="hero__eyebrow-hash">#</span> AUTONOMOUS NARRATIVE ENGINE
          </p>
          <h1 className="hero__title">BOTIFY RESOLVE</h1>
          <p className="hero__body">
            Having trouble with your $BOTIFY tokens, Migration, Staking, Bridging or Wallet Issues? Our support portal helps you diagnose and fix every issue fast.
          </p>

          <div className="hero__actions">
            <button type="button" className="zq-btn zq-btn--solid zq-btn--lg" onClick={open}>
              Connect Wallet
            </button>
            <button type="button" className="zq-btn zq-btn--outline zq-btn--lg" onClick={open}>
              Claim
            </button>
          </div>
        </div>

        <div className="hero__partners">
          <PartnersMarquee />
        </div>

        <div className="hero__mark" aria-hidden="true">
          <AsciiMark />
        </div>
      </div>
    </section>
  );
}